import { SkillForm } from "./_components/SkillForm";

export function SkillCreate() {
  return <SkillForm action="create" />;
}

export default SkillCreate;
